import * as fire from "firebase"

export const addOrder = (stateAndProps) => {
  // console.log(stateAndProps);
  return (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore()
    return firestore
      .collection("orders")
      .doc(stateAndProps.orderId)
      .set({
        ...stateAndProps,
        time: fire.firestore.FieldValue.serverTimestamp(),
      })
      .then(() => {
        console.log(`Order Successfully Set In Firestore.`)
        return true
      })
      .catch((err) => {
        console.log(`Error Adding Order To Firestore:\n${err}`)
        return false
      })
  }
}
